<template>
    <span v-if="feedShare.serving_status === 'OK'">
        OK
    </span>
    <span v-else-if="feedShare.unfulfilled_status_checkpoints.length === 0" class="text-danger">
        {{ feedShare.serving_status }}
    </span>
    <a
        v-else
        href="#"
        class="text-danger"
        style="text-decoration: underline;"
        @click="handleStatusClick"
    >
        {{ feedShare.serving_status }}
    </a>
</template>

<script>
export default {
    data() {
        return {
            feedShare: null,
        };
    },
    created() {
        this.feedShare = this.params.data;
    },
    methods: {
        handleStatusClick() {
            this.params.onStatusClick && this.params.onStatusClick(this.feedShare);
        },
    },
};
</script>
